import { render, staticRenderFns } from "./layoutApp.vue?vue&type=template&id=1f505ba4&"
import script from "./layoutApp.ts?vue&type=script&lang=ts&"
export * from "./layoutApp.ts?vue&type=script&lang=ts&"
import style0 from "./layoutApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\admin\\Documents\\baocaodieuhanh\\source\\vnta-qltp-frontend\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f505ba4')) {
      api.createRecord('1f505ba4', component.options)
    } else {
      api.reload('1f505ba4', component.options)
    }
    module.hot.accept("./layoutApp.vue?vue&type=template&id=1f505ba4&", function () {
      api.rerender('1f505ba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/presentation/layout/layoutApp.vue"
export default component.exports